export enum UserDetailsTabTypeEnum {
    SETTINGS = 'settings',
    PROJECTS = 'projects',
    EVENTS = 'events',
    ACTIVITY = 'activity',
    BILLING = 'billing',
}
